import styled from 'styled-components';

export const Main = styled.main`
  flex: 1;
  margin: 2rem auto;
  max-width: 750px;
`;

export const Feature = styled.div`
  margin: 0;
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
`;

export const FeatureTitle = styled.h2`
  margin: 0;
  padding: 0.5rem;
  text-align: center;
  color: #fff;
`;

export const FeatureAnsiedade = styled(Feature)`
  background: #f59947;
`;

export const FeatureRelacionamentos = styled(Feature)`
  background: #ea5551;
`;

export const FeatureLideranca = styled(Feature)`
  background: #3483ab;
`;

export const MainContent = styled.div`
  display: flex;
  justify-content: stretch;
  flex-direction: column;

  @media (min-width: 600px) {
    flex-direction: row;
  }
`;
